(function actionsDefinition() {
    'use strict';
    angular.module('Entities')
        .service('themeService', [
            'restUrlBuilder', function actionService(restUrlBuilder) {

                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id) {
                    return restUrlBuilder.one('Themes', id)
                        .get();
                };

                this.get = function get(name) {
                    var params = { Name: name };

                    return restUrlBuilder.all('Themes')
                        .get({ params: params });
                };
            }
        ]);
})();